import React, { PureComponent } from 'react';
import { HoverableTag } from 'Components/Pages/Results/Tags';

class TagListItem extends PureComponent {
  render() {
    const { tag } = this.props;
    return (
      <li
        data-id={tag.id}
        className="TagListItem"
        onMouseEnter={this.handleMouseEnter}
      >
        <HoverableTag showInfoWindow={true} tag={tag} />
      </li>
    );
  }
}

export default TagListItem;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/RankedLists/TagListItem.js